import { Button, Col, Container, Row } from "react-bootstrap";

function VideoSection(){
    return(
        <section id="section-video">
        <Container>
            <Row>
                <Col id="section-text">
                    
                    <h2>
                    When a man's stomach is full it makes no
        difference whether he is rich or poor.
                    </h2>
                    <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et purus a odio
        finibus bibendum in sit amet leo. Mauris feugiat erat tellus.
                    </p>
                    <Button> Watch Our Story</Button>
                    
                </Col>
            </Row>
        </Container>
        </section>
    )
}

export default VideoSection;